module.exports = __webpack_public_path__ + "img/HR.c9b8052c.png";